import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import Riya from '../assets/images/Riya.jpg'

const ZunairaTazkeerHussain = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title>Zunaira Tazkeer Hussain - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={Riya}
                    Title="Zunaira Tazkeer Hussain"
                    Designation="General Manager"
                    PhoneNumberLink="+971585724494"
                    PhoneNumber="+971 58 572 4494"
                    WhatsappLink="971585724494"
                    Whatsapp="+971 58 572 4494"
                    Email="zunaira@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={Riya}
                    Title="Zunaira Tazkeer Hussain"
                    Designation="General Manager"
                    PhoneNumberLink="+971585724494"
                    PhoneNumber="+971 58 572 4494"
                    WhatsappLink="971585724494"
                    Whatsapp="+971 58 572 4494"
                    Email="zunaira@800homes.ae"
                />
            </section>
        </>
    )
}

export default ZunairaTazkeerHussain
